var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0459 52.39C41.5143 54.8442 38.7501 54.4567 36.0893 53.2942C33.2734 52.1058 30.6901 52.0542 27.7193 53.2942C23.9993 54.8958 22.0359 54.4308 19.8143 52.39C7.2076 39.3958 9.0676 19.6075 23.3793 18.8842C26.8668 19.065 29.2951 20.7958 31.3359 20.9508C34.3843 20.3308 37.3034 18.5483 40.5584 18.7808C44.4593 19.0908 47.4043 20.6408 49.3418 23.4308C41.2818 28.2617 43.1934 38.8792 50.5818 41.85C49.1093 45.725 47.1976 49.5742 44.0201 52.4158L44.0459 52.39ZM31.0776 18.7292C30.6901 12.9683 35.3659 8.215 40.7393 7.75C41.4884 14.415 34.6943 19.375 31.0776 18.7292Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.d22847152907cce92064f949d406ac80.svg";
export { ForwardRef as ReactComponent };